.textAndButton {
  align-items: flex-start;
  flex-direction: column;
  gap: 16px;

  @media (--reefer-media-tablet-min) {
    align-items: center;
    flex-direction: row;
    gap: 24px;
  }
}

.headerText {
  font-size: 20px;
  line-height: 24px;
}

.cta {
  width: 100%;

  @media (--reefer-media-tablet-min) {
    width: auto;
  }
}
